import { render, staticRenderFns } from "./HandleOrderForm.vue?vue&type=template&id=57e039c8"
import script from "./HandleOrderForm.vue?vue&type=script&lang=js"
export * from "./HandleOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports